import * as React from 'react';

export default ({ width, height, color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width || '24'}
    height={height || '24'}
    fill="none"
    viewBox="0 0 24 24"
  >
    <g stroke={color || '#b5bfd2'} strokeWidth="2">
      <path strokeLinecap="round" strokeLinejoin="round" d="M9.5 9 5 18h14l-3-6-3 3z" />
      <circle cx="16" cy="7" r="2" />
    </g>
  </svg>
);
